module.exports = __webpack_public_path__ + "img/placeholder.5b6fe2da.png";